/* eslint-disable no-debugger */
import React, { useContext, useEffect, useState } from 'react';
import './filter.scss';
import PropTypes from 'prop-types';
import MultiSelectSearchDropdown from '../../../Components/MultiFilterSearch/multiFilterSearch';
import AddIcon from '@mui/icons-material/Add';
import ButtonComponent from '../../../Components/Button/button';
import { AuthContext } from '../../../Contexts/AuthContext';
import AddCategoryForm from '../AddCategory/addCategoryForm';
import { getUniqueCategories, getUniqueSubCategories } from '../certificationCategoryUtil';
import { MODULE_NAMES } from '../../../Constants/modules';

const Filter = ({
  buttonText,
  placeHolder,
  filterData,
  selectedCategories,
  setSelectedCategories,
  selectedSubCategories,
  setSelectedSubCategories,
  updateCategoriesList,
  isEdit,
}) => {
  const { userProfile } = useContext(AuthContext);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.MASTER_TRAINING_CERT_CATEGORY] || []
    : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  useEffect(() => {
    getUniqueCategories(filterData)
      .then(setCategoryList);

    getUniqueSubCategories(filterData)
      .then(setSubCategoryList);
  }, [filterData, isEdit]);

  const handleCategorySelection = (event) => {
    setSelectedCategories(event.target.value);
  };

  const handleSubCategorySelection = (event) => {
    setSelectedSubCategories(event.target.value);
  };

  return (
    <div className="filters-container-layout">
      <div className="filter-container">
        <div className="filter-year-container">
          <MultiSelectSearchDropdown
            dropdownCss="filter-year"
            options={categoryList}
            value={selectedCategories}
            onChange={handleCategorySelection}
            placeholder={placeHolder.CATEGORY}
            autoFocus={true}
            size="small"
            id="year-filter"
            SearchPlaceHolder={placeHolder.CATEGORY}
            showFilterIcon={false}
            disabled={categoryList.length === 0}
          />
        </div>

        <div className="filter-performance-type-container">
          <MultiSelectSearchDropdown
            dropdownCss="filter-performance-type"
            options={subCategoryList}
            value={selectedSubCategories}
            onChange={handleSubCategorySelection}
            placeholder={placeHolder.SUB_CATEGORY}
            autoFocus={true}
            size="small"
            id="performance-type-filter"
            SearchPlaceHolder={placeHolder.SUB_CATEGORY}
            showFilterIcon={false}
            disabled={subCategoryList.length === 0}
          />
        </div>
      </div>

      <div className="add-button-container">
        <ButtonComponent
          disabled={!hasAccess('create')} // Disable add button based on permission
          label={buttonText}
          variant="contained"
          onClick={() => {
            setAddModalOpen(true);
          }}
          startIcon={<AddIcon />}
          btnCss={
            !hasAccess('create') ? 'add-period-btn-disabled' : 'add-period-btn'
          }
        ></ButtonComponent>
      </div>
      <AddCategoryForm
        openAddModal={addModalOpen}
        handleClose={() => {
          setAddModalOpen(false);
        }}
        lastUpdatedBy={userProfile?.user_name}
        updateCategoriesList={updateCategoriesList}
      />
    </div>
  );
};

Filter.propTypes = {
  updateCategoriesList: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  placeHolder: PropTypes.string.isRequired,
  filterData: PropTypes.array.isRequired,
  setSelectedCategories: PropTypes.func.isRequired,
  selectedCategories: PropTypes.array.isRequired,
  selectedSubCategories: PropTypes.array.isRequired,
  setSelectedSubCategories: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
};

export default Filter;
